import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
// rxjs
import { Subject, throwError } from 'rxjs';
import { Observable } from 'rxjs';
// services
import { ErrorHandler } from './error-handler.service';
// path globals
import { API_PATH,SUBSCRIPTION_KEY, ADD_QUESTION_ANSWER, GET_QUESTION_ANSWER } from '../globals';


@Injectable({
  providedIn: 'root',
})
export class AddQuestionAnswerService {

  private _token;

  public addQuestionAnswer$: Subject<any> = new Subject();
  public questionAnswerItem$: Subject<any> = new Subject();

  constructor (
    private _http: HttpClient,
    private _errorService: ErrorHandler
  ) {}

  createAuthorizationHeader(headers: HttpHeaders, tokenFromCall?) {
    const userToken = typeof this._token === 'undefined' ? tokenFromCall : this._token;
    headers = headers.set('Authorization', 'bearer ' + userToken);
    return headers;
  }


  addQuestionAnswer(request, token) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);

    this._http.post(API_PATH + ADD_QUESTION_ANSWER, request, {headers: headers})
      .subscribe(
        res => {
          this.addQuestionAnswer$.next(true);
        },
        err => {
          this.addQuestionAnswer$.next(false);
          this._errorService.handleError(err);
          return;
      });
  }

  getQuestionAnswer(request, token) {
    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);

    this._http.post(API_PATH + GET_QUESTION_ANSWER, request, {headers: headers})
      .subscribe(
        (res:any) => {
          this.questionAnswerItem$.next(res);
        },
        err => {
          this.questionAnswerItem$.next(throwError(err));
          this._errorService.handleError(err);
          return;
      });
  }

}
